import React from 'react';
import { Modal } from 'react-bootstrap';

interface TextProps {
    title: string;
    message: string | JSX.Element;
}

interface ConfirmationDialogProps extends TextProps {
    onClose: () => void;
    onConfirm: () => void;
}

const ModalMessageStyle: React.CSSProperties = {
    display: 'block',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    overflow: 'hidden',
};

const ModalBodyStyle: React.CSSProperties = {
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    flex: 1,
    minHeight: 0,
};

// Bootstrap's `centered` + `scrollable` dialog classes already handle the flex column layout,
// the sticky header/footer and the scrolling body. Only the width cap and a definite content
// height (Bootstrap drops it for the centered + scrollable combination) have to be added.
const responsiveModalCss = `
.wfp-responsive-modal { max-width: 800px; }
.wfp-responsive-modal .modal-content { max-height: calc(100vh - 3.5rem); }
`;

function renderDialog(props: TextProps, renderButtons) {
    const { title, message } = props;
    const isStringMessage = typeof message === 'string';
    return (
        <>
            <style>{responsiveModalCss}</style>
            <Modal
                backdrop="static"
                centered
                dialogClassName="wfp-responsive-modal"
                keyboard={false}
                onHide={() => undefined}
                scrollable
                show
            >
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={ModalBodyStyle}>
                    {isStringMessage ? <p style={ModalMessageStyle}>{message as string}</p> : (message as JSX.Element)}
                </Modal.Body>
                <Modal.Footer>{renderButtons()}</Modal.Footer>
            </Modal>
        </>
    );
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
    const { onClose, onConfirm } = props;
    return renderDialog(props, () => (
        <div>
            <button className="wfp-btn" onClick={onClose} style={{ marginRight: 10 }} type="button">
                Close
            </button>
            <button className="wfp-btn--primary" onClick={onConfirm} type="submit">
                Confirm
            </button>
        </div>
    ));
}

interface InformationDialogProps extends TextProps {
    title: string;
    message: string | JSX.Element;
    onClose: () => void;
}

export function InformationDialog(props: InformationDialogProps) {
    const { onClose } = props;
    return renderDialog(props, () => (
        <button className="wfp-btn" onClick={onClose} style={{ marginRight: 10 }} type="button">
            Close
        </button>
    ));
}
